module.exports = __webpack_public_path__ + "media/images/flags/1x1/prt-c5b7c4d2959002587c96e85e207cce52.svg";